import db from './db';
const LOCALE_ID = 1;
export const getUserLocale = async () => (await db.locale.get(LOCALE_ID))?.locale;
export const setUserLocale = async locale => await db.locale.put({
  id: LOCALE_ID,
  locale
});